namespace advisorop.components.servicer {
    
    export class SelectCustodianController{  

        onCustodianSelected: any;
        showCuPanel: boolean = false;
        selCustodian: domains.ICustodian;
        selCustodianId: number;
        newCustodian: domains.ICustodian = {};
        custodians: domains.ICustodian[];

        constructor(private servicerService: services.ServicerService) {            
        }

        loadCustodians(): void {
            this.servicerService.getCustodians()
                .then(data => {
                    this.custodians = data.data;
                })
                .catch(data => {
                    toastr.warning("Custodians has not been loaded. Error " + data.error + " "  + data.data);
                });
        };

        custodianSelected(): void {
            
            if (this.selCustodian)
            {
                var custodian: domains.ICustodian = {};

                angular.copy(this.selCustodian, custodian);

                this.onCustodianSelected({ custodian: custodian });
            }
            
            //this.selCustodian = null;
        };

        initNewCustodian(): void {
            this.showCuPanel = true;
            this.newCustodian = {
                id: 0
            };
        };

        editCustodian(): void {
            this.showCuPanel = true;
            //preparing for editing...
            angular.copy(this.selCustodian, this.newCustodian);
        }

        cancelCustodian(custodian: domains.ICustodian): void {

            this.showCuPanel = false;

            this.selCustodian = null;
        };

        custodianCreated(custodian: domains.ICustodian): void {

            this.custodians.push(custodian);

            this.selCustodian = custodian;       

            this.showCuPanel = false;  
        };

        custodianModified(custodian: domains.ICustodian): void {
            
            var index = this.custodians.map(function (c) { return c.id }).indexOf(custodian.id);
            
            if (index >= 0) {

                this.custodians[index] = custodian;
                
                this.selCustodian = custodian;
            };
            
            this.showCuPanel = false;  
        };


        $onInit(): void {
            this.loadCustodians();
        }

        $onChanges(changes) {
            //currentValue, previousValue
            for (let prop in changes) {
                if (prop == "selCustodianId") {
                    //console.log(this.selCustodianId);
                    if (this.custodians) {
                        let ind = this.custodians.map(m => m.id).indexOf(this.selCustodianId);
                        this.selCustodian = this.custodians[ind];
                    }
                }
            }
        }
      

    }



    class SelectCustodian implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        
        constructor() {
            this.bindings = {       
                selCustodian: "=",
                selCustodianId: "<",
                onCustodianSelected: "&"         
            };
            this.controller = ["servicerService", SelectCustodianController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/select-custodian.html';            
        }
    }
    angular.module(Constants.APP).component("selectCustodian", new SelectCustodian());
    
}